export type CanvasGeometry = { x: number; y: number; displayWidth: number; displayHeight: number };

// PostgreSQL REAL stores IEEE-754 float32. Compare and hash at the same
// precision so a valid fractional coordinate survives a save/reload cycle.
const dbReal = (value: number) => Math.fround(value);
export function sameCanvasGeometry(a: CanvasGeometry | null | undefined, b: CanvasGeometry | null | undefined): boolean {
  return !!a && !!b && dbReal(a.x) === dbReal(b.x) && dbReal(a.y) === dbReal(b.y) &&
    dbReal(a.displayWidth) === dbReal(b.displayWidth) && dbReal(a.displayHeight) === dbReal(b.displayHeight);
}

export type CanvasGeometryChange = { clientId: string; base: CanvasGeometry | null; geometry: CanvasGeometry };

export function hasCanvasGeometryConflict(
  changes: CanvasGeometryChange[],
  payloadIds: ReadonlySet<string>,
  currentGeometry: (clientId: string) => CanvasGeometry | null | undefined,
): boolean {
  const seen = new Set<string>();
  for (const change of changes) {
    if (!change || typeof change.clientId !== 'string' || !change.clientId || seen.has(change.clientId) ||
        !change.geometry || ![change.geometry.x, change.geometry.y, change.geometry.displayWidth, change.geometry.displayHeight].every(Number.isFinite) ||
        (change.base !== null && (!change.base || ![change.base.x, change.base.y, change.base.displayWidth, change.base.displayHeight].every(Number.isFinite))) ||
        !payloadIds.has(change.clientId)) return true;
    seen.add(change.clientId);
    const current = currentGeometry(change.clientId);
    // A commit may succeed while its acknowledgement is lost. Retrying the
    // identical requested geometry is already satisfied, even on stale base.
    if (current && sameCanvasGeometry(current, change.geometry)) continue;
    if (change.base === null ? !!current && !sameCanvasGeometry(current, change.geometry) : !current || !sameCanvasGeometry(current, change.base)) return true;
  }
  return false;
}

export function canvasGeometryRevision(rows: Array<{ clientId: string } & CanvasGeometry>): string {
  return JSON.stringify(rows.map(({ clientId, x, y, displayWidth, displayHeight }) => ({ clientId, x:dbReal(x), y:dbReal(y), displayWidth:dbReal(displayWidth), displayHeight:dbReal(displayHeight) }))
    .sort((a, b) => a.clientId.localeCompare(b.clientId)));
}
